module.exports = __webpack_public_path__ + "2cece61140196a6330a58d512d8ed0d0.jpg";